import { LocalizationProvider } from "@mui/x-date-pickers";
import BasicListDataGetter from "../../utils/MuiTableUtils/BasicListDataGetter";
import _ from "lodash";
import { MaterialReactTable } from "material-react-table";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export const MuiTableComponent = ({
  route,
  customFilter,
  customSort,
  table,
}) => {
  return (
    <>
      <BasicListDataGetter
        route={route}
        customFilter={customFilter}
        customSort={customSort}
      />
      <LocalizationProvider dateAdapter={AdapterMoment}>
        {!_.isEmpty(table) && <MaterialReactTable table={table} />}
      </LocalizationProvider>
    </>
  );
};
